import script from "./elementItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./elementItem.vue?vue&type=script&lang=ts&setup=true"

import "./elementItem.vue?vue&type=style&index=0&id=c9915d78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9915d78"]])

export default __exports__